import { Cancel01Icon } from '@hugeicons/react'

import { Button } from '@/shared/ui/Button'

type StoreCatalogFilterPillsProps = {
  available: boolean
  soldOut: boolean
  requested: boolean
  affordable: boolean
  walletReady: boolean
  onToggleAvailable: () => void
  onToggleSoldOut: () => void
  onToggleRequested: () => void
  onToggleAffordable: () => void
}

type PillProps = {
  active: boolean
  label: string
  disabled?: boolean
  onClick: () => void
}

const StoreFilterPill = ({ active, label, disabled = false, onClick }: PillProps) => (
  <Button
    type="button"
    size="sm"
    variant={active ? 'primary' : 'primary-ghost'}
    aria-pressed={active}
    disabled={disabled}
    onClick={onClick}
    className="!rounded-2xl shrink-0"
    showTrailingIcon={active}
    trailingIcon={
      active ? <Cancel01Icon style={{ width: '1rem', height: '1rem' }} /> : undefined
    }
  >
    {label}
  </Button>
)

export const StoreCatalogFilterPills = ({
  available,
  soldOut,
  requested,
  affordable,
  walletReady,
  onToggleAvailable,
  onToggleSoldOut,
  onToggleRequested,
  onToggleAffordable
}: StoreCatalogFilterPillsProps) => (
  <div
    role="group"
    aria-label="Filtrar recompensas"
    className="flex gap-3 overflow-x-auto pb-0.5 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
  >
    <StoreFilterPill
      active={available}
      label="Apenas disponíveis"
      onClick={onToggleAvailable}
    />
    <StoreFilterPill
      active={soldOut}
      label="Esgotados"
      onClick={onToggleSoldOut}
    />
    <StoreFilterPill
      active={affordable}
      label="Reserváveis"
      disabled={!walletReady}
      onClick={onToggleAffordable}
    />
    <StoreFilterPill
      active={requested}
      label="Reservados"
      onClick={onToggleRequested}
    />
  </div>
)

StoreCatalogFilterPills.displayName = 'StoreCatalogFilterPills'
